/**
 * PM Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WooProductImage } from './wooProductImage';
import { BrandedNumberDto } from './brandedNumberDto';


export interface VariationTranslationDto { 
    _id?: object;
    sku: string;
    regular_price: Array<BrandedNumberDto>;
    sale_price: Array<BrandedNumberDto>;
    price_offset: number;
    stock_status: string;
    status: VariationTranslationDto.StatusEnum;
    description: string | null;
    image?: WooProductImage | null;
    attributes: Array<object>;
}
export namespace VariationTranslationDto {
    export const StatusEnum = {
        draft: 'draft',
        pending: 'pending',
        private: 'private',
        publish: 'publish'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


